import React, { useState, useEffect } from "react";
import Grid from '@material-ui/core/Grid'
import SearchIcon from '@material-ui/icons/Search';
import Card from '../../Components/Cards/index'

import '../browser.css'

import srcimg from '../../img/brow/pancakeswaplogo.png'

/* ***********************
**   Import Web3
*********************** */
import Web3 from "web3";

/* ***********************
**   Import Web3
*********************** */
var web3;
var address;
var abi;
var contract;
var contract2;
var rewAdd;
var rewAbi;
var contractCont;
var rewAddCont;
var rewABICont;
var accounts = [];
let finalAccount;
let modlemsgETH;
let modlemsgBNB;


const Tokens = () => {
  const [allData,setAllData] = useState([]);
  const [filteredData,setFilteredData] = useState(allData);
  
  /***************************************************
  *
  *    Connecting Metamask
  *    Creating Contract object
  *    Save Wallet address in varibale
  *
  ****************************************************/

  //  var data = {};
  //  var element = {};
  //  var queue = new Array();
  //  let i = '0'
  //   useEffect(()=> {
  //     //if metamask is installed
  //     if(window.web3 !== undefined){
  //       //connect to web3
  //       web3 = new Web3(window.ethereum);
  //       // gasPrice's contract's credentials
  //       address = '0xC765bddB93b0D1c1A88282BA0fa6B2d00E3e0c83';
  //       abi = [{"inputs":[{"internalType":"contract IUniFactory","name":"_uniswapFactory","type":"address"}],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"lpToken","type":"address"},{"indexed":false,"internalType":"address","name":"user","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"lockDate","type":"uint256"},{"indexed":false,"internalType":"uint256","name":"unlockDate","type":"uint256"}],"name":"onDeposit","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"lpToken","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"}],"name":"onWithdraw","type":"event"},{"inputs":[],"name":"MIGRATION_IN","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"gFees","outputs":[{"internalType":"uint256","name":"ethFee","type":"uint256"},{"internalType":"contract IERCBurn","name":"secondaryFeeToken","type":"address"},{"internalType":"uint256","name":"secondaryTokenFee","type":"uint256"},{"internalType":"uint256","name":"secondaryTokenDiscount","type":"uint256"},{"internalType":"uint256","name":"liquidityFee","type":"uint256"},{"internalType":"uint256","name":"referralPercent","type":"uint256"},{"internalType":"contract IERCBurn","name":"referralToken","type":"address"},{"internalType":"uint256","name":"referralHold","type":"uint256"},{"internalType":"uint256","name":"referralDiscount","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"_index","type":"uint256"}],"name":"getLockedTokenAtIndex","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getNumLockedTokens","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_lpToken","type":"address"}],"name":"getNumLocksForToken","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_user","type":"address"},{"internalType":"address","name":"_lpToken","type":"address"},{"internalType":"uint256","name":"_index","type":"uint256"}],"name":"getUserLockForTokenAtIndex","outputs":[{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"uint256","name":"","type":"uint256"},{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_user","type":"address"},{"internalType":"uint256","name":"_index","type":"uint256"}],"name":"getUserLockedTokenAtIndex","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_user","type":"address"}],"name":"getUserNumLockedTokens","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_user","type":"address"},{"internalType":"address","name":"_lpToken","type":"address"}],"name":"getUserNumLocksForToken","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_user","type":"address"}],"name":"getUserWhitelistStatus","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"_index","type":"uint256"}],"name":"getWhitelistedUserAtIndex","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getWhitelistedUsersLength","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_lpToken","type":"address"},{"internalType":"uint256","name":"_index","type":"uint256"},{"internalType":"uint256","name":"_lockID","type":"uint256"},{"internalType":"uint256","name":"_amount","type":"uint256"}],"name":"incrementLock","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_lpToken","type":"address"},{"internalType":"uint256","name":"_amount","type":"uint256"},{"internalType":"uint256","name":"_unlock_date","type":"uint256"},{"internalType":"address payable","name":"_referral","type":"address"},{"internalType":"bool","name":"_fee_in_eth","type":"bool"},{"internalType":"address payable","name":"_withdrawer","type":"address"}],"name":"lockLPToken","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"address","name":"_lpToken","type":"address"},{"internalType":"uint256","name":"_index","type":"uint256"},{"internalType":"uint256","name":"_lockID","type":"uint256"},{"internalType":"uint256","name":"_amount","type":"uint256"}],"name":"migrate","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_lpToken","type":"address"},{"internalType":"uint256","name":"_index","type":"uint256"},{"internalType":"uint256","name":"_lockID","type":"uint256"},{"internalType":"uint256","name":"_unlock_date","type":"uint256"}],"name":"relock","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address payable","name":"_devaddr","type":"address"}],"name":"setDev","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_referralPercent","type":"uint256"},{"internalType":"uint256","name":"_referralDiscount","type":"uint256"},{"internalType":"uint256","name":"_ethFee","type":"uint256"},{"internalType":"uint256","name":"_secondaryTokenFee","type":"uint256"},{"internalType":"uint256","name":"_secondaryTokenDiscount","type":"uint256"},{"internalType":"uint256","name":"_liquidityFee","type":"uint256"}],"name":"setFees","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_migrationIn","type":"address"}],"name":"setMigrationIn","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"contract IMigrator","name":"_migrator","type":"address"}],"name":"setMigrator","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"contract IERCBurn","name":"_referralToken","type":"address"},{"internalType":"uint256","name":"_hold","type":"uint256"}],"name":"setReferralTokenAndHold","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_secondaryFeeToken","type":"address"}],"name":"setSecondaryFeeToken","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_lpToken","type":"address"},{"internalType":"uint256","name":"_index","type":"uint256"},{"internalType":"uint256","name":"_lockID","type":"uint256"},{"internalType":"uint256","name":"_amount","type":"uint256"}],"name":"splitLock","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"},{"internalType":"uint256","name":"","type":"uint256"}],"name":"tokenLocks","outputs":[{"internalType":"uint256","name":"lockDate","type":"uint256"},{"internalType":"uint256","name":"amount","type":"uint256"},{"internalType":"uint256","name":"initialAmount","type":"uint256"},{"internalType":"uint256","name":"unlockDate","type":"uint256"},{"internalType":"uint256","name":"lockID","type":"uint256"},{"internalType":"address","name":"owner","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_lpToken","type":"address"},{"internalType":"uint256","name":"_index","type":"uint256"},{"internalType":"uint256","name":"_lockID","type":"uint256"},{"internalType":"address payable","name":"_newOwner","type":"address"}],"name":"transferLockOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"uniswapFactory","outputs":[{"internalType":"contract IUniFactory","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_user","type":"address"},{"internalType":"bool","name":"_add","type":"bool"}],"name":"whitelistFeeAccount","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_lpToken","type":"address"},{"internalType":"uint256","name":"_index","type":"uint256"},{"internalType":"uint256","name":"_lockID","type":"uint256"},{"internalType":"uint256","name":"_amount","type":"uint256"}],"name":"withdraw","outputs":[],"stateMutability":"nonpayable","type":"function"}];
  //       contract = new web3.eth.Contract(abi, address);
        
  //         for(i = 0; i<=10; i++)  {
  //           contract.methods.getLockedTokenAtIndex(i).call().then( tokenaddress => {
  //             contract.methods.getNumLocksForToken(tokenaddress).call().then( numLocksForToken => {
  //               // console.log("BrosF : ",numLocksForToken +" : "+ result)
  //               queue.push({tokenaddress,numLocksForToken})
  //               // setAllData(queue);
  //               // setFilteredData(queue);
  //             });
  //           })
            
  //         }
  //         console.log('testsf : ', queue)
  //         setAllData(queue);
  //         setFilteredData(queue);

  //         console.log('testsf1 : ', allData)
  //         console.log('testsf2 : ', filteredData)

  //   }
  //   else{
  //       //if Metamask is not installed
  //   }
  //   },[]);

  /*******************
  *
   Search Bar
  *
  ********************/
   useEffect(() => {
    const requestOptions = {
      method: 'GET',
      headers: {
          'Content-Type': 'application/json',
      },
    };
    fetch('https://coinvanci-g.herokuapp.com/category',requestOptions)
    .then(response => response.json())
    .then(response => {
    console.log('fectumTest: ', response)
    setAllData(response);
    setFilteredData(response);
    })
    .catch(error => {
    console.log('Error getting fake data: ' + error);
    })
    }, []);

    const handleSearch = (event) => {
      let value = event.target.value.toLowerCase();
      let result = [];
      // result = allData.filter((data) => {
      //   let tesfer = "";
      //   // tesfer = tesfer = data.Title.search(value) != -1;
      //   // tesfer = data.address.search(value)!= -1;
      //   return (
      //     data.Title.search(value)!= -1
      //   );
      // });
      let str = value;
      let res = str.substring(0, 2);
      if( res == '0x' ){
        result = allData.filter(x => x.address.toLowerCase().includes(value.toLowerCase()));
      }else{
        result = allData.filter(x => x.Title.toLowerCase().includes(value.toLowerCase()));
      }
      setFilteredData(result);
    }

   
  return (
    <div className="pcc---slider" style={{backgroundColor:'#f6f6f6'}}>
        <Grid
            container
            justify="center"
            alignItems="center"
            className="px-0"
        >
            <Grid 
                container 
                justify="center" 
                direction="column"
                md={8}
                className="py-md-3"
            >
            <Grid 
                container 
                justify="center" 
                direction="column"
                md={12}
            >
                <h6 className="text-center py-4"><strong>All Tokens</strong></h6>
            </Grid>
            <Grid 
                container 
                justify="center" 
                direction="column"
                md={12}
            >
                <div className='pc---input mb-4'>
                <img src={srcimg} for="#search" />
                <input type="text" onChange={(event) =>handleSearch(event)} id="search" placeholder="Token name or address" />
                <SearchIcon  for="#search"  />
                </div>
            </Grid>
            <Grid 
                container 
                justify="center" 
                direction="column"
                md={12}
            >
                <div style={{maxWidth:'-webkit-fill-available'}}>
                {filteredData.map((value,index)=>{
                return(
                <div key={value.id}>
                    <div >
                    <Card />
                    {value.tokenaddress} {value.numLocksForToken} <br />
                    </div>
                </div>
                )
                })}
                </div>
            </Grid>
            </Grid>
        </Grid>
    </div> 
  );
}

export default Tokens;
